module.exports = __webpack_public_path__ + "r-v3/img/emoti-surprise.8ac0c9d6.svg";